module.exports = __webpack_public_path__ + "img/202506_01.fc9790ad.jpg";